import { createSlice } from "@reduxjs/toolkit";

interface initalStateInterface{
  filter: {
    page: number,
    limit: number,
  },
  dropDown: {
    designation:{id:string |number | null ,label:string|number | null},
    employeeStatus:{id:string | number| null,label:string | string |null},
    expenseStatus:{id:null|number|string, label:string| number | null},
  },
};

const initialState:initalStateInterface = {
  filter: {
    page: 1,
    limit: 10,
  },
  dropDown: {
    designation:{id: '', label: 'All'},
    employeeStatus:{id: null, label: 'All'},
    expenseStatus:{id: 'null', label: 'All'},
  },
};

const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.filter.page = action.payload;
    },
    setLimit: (state, action) => {
      state.filter.limit = action.payload;
    },
    setDesignation: (state, action) => {
      state.dropDown.designation = action.payload;
    },
    setEmployeeStatus: (state, action) => {
      state.dropDown.employeeStatus = action.payload;
    },
    setExpenseStatus: (state, action) => {
      state.dropDown.expenseStatus = action.payload;
    },
    // optional: reset all dropdowns
    resetDropDown: (state) => {
      state.dropDown = {
        designation:{id: '', label: ''},
        employeeStatus:{id: null, label: 'All'},
        expenseStatus:{id: 'null', label: 'All'}
        };
    },
    resetPagination:(state)=>{
        state.filter={
          page: 1,
          limit: 10,
        }
    }
  },
});

export const {
  setPage,
  setLimit,
  setDesignation,
  setEmployeeStatus,
  setExpenseStatus,
  resetDropDown,
  resetPagination
} = employeeSlice.actions;

export default employeeSlice.reducer;
